<div class="common-modal__container">
  <!-- Cabecera -->
  <div class="common-modal__header">
    <span class="common-modal__text-header"
      [afTranslate]="'form-configuration-modal.form-configuration'">_Configuración del formulario</span>
  </div>
  <!-- Contenedor -->
  @if(configuration.conceptInfo.hasInstances && formConfiguration.showMessage){
    <div class="common-status-message__g-container-warning">
      <i class="lf-icon-warning-full common-status-message__icon-md"></i>
      <div class="common-status-message__g-content">
          <div class="common-status-message__g-icon-text-content">
            <div class="common-status-message__g-title-subtitle">
              <span class="common-status-message__g-subtitle"
                [afTranslate]="'customize-concept.restricted-edition-concept'">_El concepto ya ha sido evaluado. No podrás eliminar contenido en uso ni tampoco modificar algunas configuraciones.</span>
            </div>
            <button class="common-button__icon-xs-noborder"
              (click)="formConfiguration.showMessage = false">
              <i class="lf-icon-close-thick common-icon__sm"></i>
            </button>
          </div>
      </div>
    </div>
  }
  @if(formConfiguration.faceview === 'group'){
    <div class="common-modal__content-scroll">
      <div class="form-configuration-modal__group-items-container">
        <p class="common-modal__content-header-info"
          [afTranslate]="'form-configuration-modal.info-modal'">_Añade tus campos personalizados. Este grupo de campos se visualizará al principio del formulario.</p>
        <div class="form-configuration-modal__group-container">
          <div class="customize-concept__group-container-title">
            <div class="common-section-title__param-container">
              <div class="common-section-title__param-inner-container">
                <div class="common-section-title__param-band">
                  <div class="common-section-title__param-title-band-container">
                    <div [ngClass]="{'common-section-title__param-label-icons-container': !formConfiguration.fieldContainer.editableName,
                      'common-section-title__param-input-icons-group': formConfiguration.fieldContainer.editableName && !formConfiguration.fieldContainer.error,
                      'common-section-title__param-input-icons-container-error': formConfiguration.fieldContainer.editableName && formConfiguration.fieldContainer.error}">
                      @if(formConfiguration.fieldContainer.editableName){
                        <input type="text"
                          [id]="'group-form-configuration-'+formConfiguration.fieldContainer.fieldContainerId"
                          class="common-section-title__param-input-group"
                          [(ngModel)]="formConfiguration.fieldContainer.name"
                          [disabled]="formConfiguration.disabledGroup"
                          pAutoFocus
                          [autofocus]="formConfiguration.fieldContainer.editableName"
                          maxlength="300"
                          (blur)="fieldContainerNameChange(formConfiguration.fieldContainer)">
                      }@else {
                        <span-tooltip class="common-section-title__param-label-band"
                          [text]="formConfiguration.fieldContainer.name"></span-tooltip>
                      }
                    </div>
                  </div>
                  @if(!formConfiguration.disabledGroup){
                    @if(formConfiguration.fieldContainer.editableName){
                      <button class="common-button__icon-md-noborder"
                        (click)="fieldContainerNameChange(formConfiguration.fieldContainer)"
                        [disabled]="formConfiguration.fieldContainer.error">
                        <i class="lf-icon-check common-icon__md"></i>
                      </button>
                    }@else {
                      <button class="common-button__icon-md-noborder"
                        (click)="formConfiguration.fieldContainer.editableName = true">
                        <i class="lf-icon-editable-form common-icon__md"></i>
                      </button>
                    }
                  }
                </div>
              </div>
              @if(formConfiguration.fieldContainer.error){
                <div class="common-section-title__param-error-container">
                  <span [afTranslate]="'common.field-mandatory'">_Campo obligatorio</span>
                </div>
              }
            </div>
            <div class="form-configuration-modal__group-buttons-container">
              <button-with-text-menu
                [item]="formConfiguration.fieldList"
                [disabled]="formConfiguration.disabledGroup"
                [icon]="'lf-icon-add-round'"
                [textButton]="'customize-concept.add-field'"
                [multiline]="1"
                (launchActionEmitter)="addNewField($event.option)">
              </button-with-text-menu>
            </div>
          </div>
          <div class="form-configuration-modal__fields-container"
            cdkDropList
            [cdkDropListData]="formConfiguration.fieldContainer.fields"
            (cdkDropListDropped)="reorderFields($event)">
            @for (containerField of formConfiguration.fieldContainer.fields; track $index) {
              <div class="customize-concept__field-item"
                [id]="containerField.fieldId"
                cdkDrag>
                <customize-fields [field]="containerField"
                  [previewMode]="true"
                  [typeView]="'channelView'"
                  [fieldContainer]="formConfiguration.fieldContainer"
                  [concept]="formConfiguration.conceptInfo"
                  (launchAction)="launchAction($event)">
                </customize-fields>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
    <!-- Footer botonera -->
    <div class="common-modal__footer-container-end">
      @if(formConfiguration.fieldContainer.fields?.length){
        <div class="form-configuration-modal__footer-reports-container">
          <span class="form-configuration-modal__footer-reports-text"
            [afTranslate]="'form-configuration-modal.show-channel-report'">_Mostrar en el informe del canal</span>
          <button-with-text-menu-arrow
            [item]="formConfiguration.channelReportItem"
            [list]="formConfiguration.channelReportList"
            [selectedOption]="formConfiguration.selectedChannelReportField"
            [disabled]="formConfiguration.disabledReport"
            (launchActionEmitter)="selectChannelReport($event.option)">
          </button-with-text-menu-arrow>
        </div>
      }
      <div class="common-modal__footer">
        <button class="common-button__text"
          (click)="saveConfiguration()">
          <span class="common-button__text-title">Aceptar</span>
        </button>
      </div>
    </div>
  }@else {
    <div class="form-configuration-modal__container-fields">
      <customize-fields class="flex overflow-hidden"
        [field]="formConfiguration.newField"
        [actionType]="formConfiguration.actionTypeField"
        [typeView]="'channelView'"
        [disabled]="formConfiguration.disabledGroup"
        [fieldContainer]="formConfiguration.fieldContainer"
        [concept]="formConfiguration.conceptInfo"
        (launchAction)="launchAction($event)">
      </customize-fields>
      <div class="form-configuration-modal__footer">
        @if(formConfiguration.actionTypeField === 'edit' && !configuration.conceptInfo.hasInstances){
          <button class="common-button__text-noborder"
            (click)="deleteField()">
            <span class="common-button__text-title"
              [afTranslate]="'expanded-menu.delete-field'">_Eliminar campo</span>
          </button>
        }
        <button class="common-button__text-border"
          [disabled]="formConfiguration.conceptInfo?.disabled"
          (click)="closeField()">
          <span class="common-button__text-title"
            [afTranslate]="'common.cancel'">_Cancelar</span>
        </button>
        <button class="common-button__text"
          [disabled]="formConfiguration.conceptInfo?.disabled"
          (click)="saveField()">
          <span class="common-button__text-title"
            [afTranslate]="'common.save'">_Guardar</span>
        </button>
      </div>
    </div>
  }
</div>
